module.exports = [{"author":"Roberto Gallenda","title":"Scottish","albumname":"","src":"/audio/scottish.mp3","thumb":"","duration":"04:13"},{"author":"Tradizionale","title":"Gigo occitano","albumname":"","src":"/audio/gigo.mp3","thumb":"","duration":"03:56"},{"author":"Tradizionale","title":"Circolo circassiano","albumname":"","src":"/audio/circolo.mp3","thumb":"","duration":"03:33"},{"author":"Tradizionale","title":"Bourrée a 2 tempi","albumname":"","src":"/audio/bourree.mp3","thumb":"","duration":"04:07"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/traks.json
// module id = 289
// module chunks = 0